export default __webpack_public_path__ + "static/media/image6.fc926d63.jpg";